import { apiGatewayClient } from "../clients";

export type UserHandbookDto = {
  url: string | null;
};

export const inventoryApi = {
  fetchUserHandbook: async (): Promise<UserHandbookDto> => {
    const { data } = await apiGatewayClient.request<UserHandbookDto>({
      url: "/inventory/v1.1.0/member/user/handbook",
    });
    return data;
  },
};
